import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: 'auto !important',
    maxWidth: 1366,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    color: 'black',
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 50px)',
  },

  leftWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },

  logoContainer: {
    width: '200px',
    height: 'auto',
    overflow: 'hidden',
    textAlign: 'left',

    '& img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'block',
      objectFit: 'cover',
    },
  },

  connectBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '16px',
    width: '480px',
  },

  textFoot: {
    marginTop: 10,
    fontSize: '12px',
    color: '#5C5F5D',
    textAlign: 'left',
    margin: '0 0 12px',
  },

  textOption: {
    fontSize: '14.5px',
    lineHeight: '19px',
    fontWeight: '400',
  },

  formTitle: {
    marginTop: 0,
    marginBottom: 0,
    width: '100%',
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#002116 !important',
  },

  formSubTitle: {
    marginTop: 0,
    marginBottom: 5,
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
  },

  authorizationBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '0.25rem',
    width: '100%',
    height: '100%',
    maxHeight: '20rem',
    overflowY: 'auto',

    '@media (max-width: 1380px) and (max-height: 800px)': {
      maxHeight: '6rem',
    },
  },
}))

export { useStyles }
